import request from '@/utils/request'
import { getToken } from '../../utils/auth'

// 查询出入登记
export function querypersonaccesslog (params, data) {
  params.token = getToken()
  return request({ url: '/querypersonaccesslog', method: 'post', params, data })
}

// 创建出入登记
export function createpersonaccesslog (data) {
  return request({ url: '/createpersonaccesslog', method: 'post', params: { token: getToken() }, data })
}

// 更新出入登记
export function updatepersonaccesslog (data) {
  return request({ url: '/updatepersonaccesslog', method: 'post', params: { token: getToken() }, data })
}



// WEBPACK FOOTER //
// ./src/api/yanglaoyuan/personaccesslog.js